import { Box, Stack, Typography, useTheme } from "@mui/material";
import { delftBlue } from "@/theme/colors";

const StatusIndicator = ({ lastUpdated = "2 min ago" }) => {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      sx={{
        alignSelf: "stretch",
      }}
    >
      <Box
        sx={{
          width: 8,
          height: 8,
          borderRadius: "50%",
          background: theme.palette.success.main,
        }}
      />
      <Typography
        sx={{
          color: delftBlue[500],
          fontSize: { xs: 12, sm: 13 },
          fontFamily: "Montserrat, sans-serif",
          fontWeight: 400,
          lineHeight: 1.54,
        }}
      >
        Last updated: {lastUpdated}
      </Typography>
    </Stack>
  );
};

export default StatusIndicator;



